import Header from "../components/Header";
import Footer from "../components/Footer";
import ComparisonHero from "../components/ComparisonHero";
import ComparisonTable from "../components/ComparisonTable";
import ComparisonCTA from "../components/ComparisonCTA";
import ComparisonVerdict from "../components/ComparisonVerdict";
import SEOHead from "../components/SEOHead";
import Breadcrumbs from "../components/Breadcrumbs";
import { comparisons } from "../data/comparisons";

import { useTranslation } from 'react-i18next';
const data = comparisons.zapier;

const FEATURES = data.features;

const WHEN_CHOOSE_MAXOS = data.whenChooseMaxOs;

const WHEN_CHOOSE_COMPETITOR = data.whenChooseCompetitor;

const VERDICT = data.verdict;

const HONEST_NOTE = data.honestNote;

export default function VsZapier() {
  const { t } = useTranslation();
  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Comparisons", path: null },
    { label: "Max OS vs Zapier", path: null },
  ];

  return (
    <div className="min-h-screen bg-[#09090B] text-white">
      <SEOHead
        title={data.seo.title}
        description={data.seo.description}
        url={data.seo.url}
        structuredData={data.seo.faqSchema}
      />
      <Header />

      <main id="main-content">
        <Breadcrumbs items={breadcrumbItems} />

        <ComparisonHero
          competitor={data.competitorName}
          headline={data.hero.headline}
          subheadline={data.hero.subheadline}
          maxOsTagline={data.hero.maxOsTagline}
          competitorTagline={data.hero.competitorTagline}
        />

        <ComparisonTable
          features={FEATURES}
          maxOsName="Max OS Cloud"
          competitorName={data.competitorName}
        />

        {/* When to choose Max OS */}
        <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
          <div className="text-center mb-12">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-6">
              // WHEN TO CHOOSE MAX OS
            </div>
            <h2 className="font-display text-3xl md:text-5xl uppercase leading-[0.95] max-w-3xl mx-auto">
              When to choose
              <br />
              <span className="text-amber-500">{t('vs_zapier.max_os_cloud')}</span> over {data.competitorName}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {WHEN_CHOOSE_MAXOS.map((reason, idx) => (
              <div key={idx} className="flex items-start gap-4 bg-zinc-950/60 border border-zinc-800 p-6">
                <svg className="w-5 h-5 text-amber-500 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                <div>
                  <p className="text-white font-medium mb-1">{reason.title}</p>
                  <p className="text-zinc-400 text-sm leading-relaxed">{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* When Zapier might be enough */}
        <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
          <div className="text-center mb-12">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-6">
              // WHEN ZAPIER MIGHT BE ENOUGH
            </div>
            <h2 className="font-display text-3xl md:text-5xl uppercase leading-[0.95] max-w-3xl mx-auto">
              When {data.competitorName} might
              <br />
              <span className="text-zinc-300">{t('common.auth_subtitle')}</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {WHEN_CHOOSE_COMPETITOR.map((reason, idx) => (
              <div key={idx} className="flex items-start gap-4 bg-zinc-950/40 border border-zinc-800/60 p-6">
                <svg className="w-5 h-5 text-zinc-400 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                <div>
                  <p className="text-zinc-200 font-medium mb-1">{reason.title}</p>
                  <p className="text-zinc-500 text-sm leading-relaxed">{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Verdict */}
        <ComparisonVerdict
          competitor={data.competitorName}
          verdict={VERDICT}
          honestNote={HONEST_NOTE}
        />

        {/* CTA */}
        <ComparisonCTA
          competitor={data.competitorName}
          cta={data.cta}
        />
      </main>

      <Footer />
    </div>
  );
}
